/**
 * @generated SignedSource<<7fbebd3d088105a60b07446958ed4717>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OnboardingActivitiesScreenQuery$variables = Record<PropertyKey, never>;
export type OnboardingActivitiesScreenQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"OnboardingActivitiesView_query">;
};
export type OnboardingActivitiesScreenQuery = {
  response: OnboardingActivitiesScreenQuery$data;
  variables: OnboardingActivitiesScreenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "OnboardingActivitiesScreenQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "OnboardingActivitiesView_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "OnboardingActivitiesScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Literal",
            "name": "orderBy",
            "value": [
              "SEQUENCE_ASC"
            ]
          }
        ],
        "concreteType": "ActivityConnection",
        "kind": "LinkedField",
        "name": "activities",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Activity",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "rowId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "svg",
                "storageKey": null
              },
              (v0/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": "activities(orderBy:[\"SEQUENCE_ASC\"])"
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "orderBy",
                "value": [
                  "ACTIVITY_BY_ACTIVITY_ID__SEQUENCE_ASC"
                ]
              }
            ],
            "concreteType": "UserActivityConnection",
            "kind": "LinkedField",
            "name": "userActivities",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UserActivity",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "activityId",
                    "storageKey": null
                  },
                  (v0/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": "userActivities(orderBy:[\"ACTIVITY_BY_ACTIVITY_ID__SEQUENCE_ASC\"])"
          },
          (v0/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "bd5c2a9def7ab1eaf4ab2c898c533f6d",
    "id": null,
    "metadata": {},
    "name": "OnboardingActivitiesScreenQuery",
    "operationKind": "query",
    "text": "query OnboardingActivitiesScreenQuery {\n  ...OnboardingActivitiesView_query\n}\n\nfragment OnboardingActivitiesView_query on Query {\n  activities(orderBy: [SEQUENCE_ASC]) {\n    nodes {\n      name\n      rowId\n      svg\n      id\n    }\n  }\n  ...useUserActivities_query\n}\n\nfragment useUserActivities_query on Query {\n  currentUser {\n    userActivities(orderBy: [ACTIVITY_BY_ACTIVITY_ID__SEQUENCE_ASC]) {\n      nodes {\n        activityId\n        id\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "945098677d49fba25cde68a02e8f8a76";

export default node;
